import {
  NEW_GENERIC_INPUT_DIALOG,
  SET_CONTENT,
  SHOW_DIALOG,
  SET_RESOLVE,
  RESET_STATE
} from "./constants";

const regex = /^(genericInputDialog\/)/;

const _NEW_TEXT_INPUT_DIALOG = NEW_GENERIC_INPUT_DIALOG.replace(regex, "");

export default {
  async [_NEW_TEXT_INPUT_DIALOG](
    { commit },
    {
      title,
      okText = "Ok",
      cancelText = "Cancel",
      onOk = () => {},
      onCancel = () => {},
      maxWidth = null,
      icon = null,
      content = [],
      autofocus = null,
      layer = 0
    }
  ) {
    commit(SET_CONTENT, {
      title,
      okText,
      cancelText,
      onOk,
      onCancel,
      maxWidth,
      icon,
      content,
      autofocus,
      layer
    });
    const promise = new Promise(resolve => {
      commit(SET_RESOLVE, resolve);
    });
    commit(SHOW_DIALOG, true);
    const result = await promise;
    commit(RESET_STATE);
    return result;
  }
};
